import React from "react";
import "./PolicyPages.css";

const Privacy = () => {
  return (
    <div className="policy-page">
      <div className="policy-header">
        <h1>Privacy Policy</h1>
        
      </div>

      <div className="policy-content">
        <section className="policy-section">
          <h2>Vero Disruptors Personal Information Protection Policy</h2>
          <p>
            Vero Disruptors Private Limited ("we," "our," or "us") is committed to protecting your privacy. 
            This Privacy Policy explains how we collect, use, disclose, and safeguard your information when 
            you visit our website or use our services.
          </p>
        </section>

        <section className="policy-section">
          <h2>Information We Collect</h2>
          <h3>Personal Information</h3>
          <p>We may collect personal information that you voluntarily provide to us, including:</p>
          <ul>
            <li>Name and contact information (email, phone number, address)</li>
            <li>Company information and job title</li>
            <li>Payment information for services</li>
            <li>Communication preferences</li>
          </ul>

          <h3>Automatically Collected Information</h3>
          <p>When you visit our website, we may automatically collect:</p>
          <ul>
            <li>IP address and browser type</li>
            <li>Pages visited and time spent on site</li>
            <li>Referring website information</li>
            <li>Device information and operating system</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>How We Use Your Information</h2>
          <p>We use the information we collect for various purposes:</p>
          <ul>
            <li>To provide and maintain our services</li>
            <li>To process your transactions and payments</li>
            <li>To communicate with you about updates, offers, and promotions</li>
            <li>To improve our website and services</li>
            <li>To comply with legal obligations</li>
            <li>To protect our rights and prevent fraud</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>Data Security</h2>
          <p>
            We implement appropriate technical and organizational security measures to protect your 
            personal information against unauthorized access, alteration, disclosure, or destruction. 
            However, no method of transmission over the Internet or electronic storage is 100% secure.
          </p>
        </section>

        <section className="policy-section">
          <h2>Data Retention</h2>
          <p>
            We retain your personal information only for as long as necessary to fulfill the purposes 
            outlined in this Privacy Policy, unless a longer retention period is required or permitted by law.
          </p>
        </section>

        <section className="policy-section">
          <h2>Your Rights</h2>
          <p>Depending on your location, you may have the following rights regarding your personal data:</p>
          <ul>
            <li>The right to access your personal data</li>
            <li>The right to correct inaccurate data</li>
            <li>The right to delete your personal data</li>
            <li>The right to restrict or object to processing</li>
            <li>The right to data portability</li>
            <li>The right to withdraw consent</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>Third-Party Services</h2>
          <p>
            Our website may contain links to third-party websites. We have no control over and assume 
            no responsibility for the content, privacy policies, or practices of any third-party sites 
            or services.
          </p>
        </section>

        <section className="policy-section">
          <h2>Children's Privacy</h2>
          <p>
            Our services are not intended for individuals under the age of 18. We do not knowingly 
            collect personal information from children. If you become aware that a child has provided 
            us with personal information, please contact us.
          </p>
        </section>

        <section className="policy-section">
          <h2>Changes to This Policy</h2>
          <p>
            We may update our Privacy Policy from time to time. We will notify you of any changes by 
            posting the new Privacy Policy on this page.
          </p>
        </section>

        <section className="policy-section contact-section">
          <h2>Contact Us</h2>
          <p>If you have questions about this Privacy Policy, please contact us:</p>
          <div className="contact-info">
            <p><strong>Email:</strong> venkatmor@verodisruptors.com</p>
            <p><strong>Phone:</strong> +91 9032584791</p>
            <p>
              <strong>Address:</strong> H.No: 3-77, Thimmanapalem(V),
Korisapadu (MD), Bapatla (DT),
Andhra Pradesh, India - 523212
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Privacy;